import React from 'react';

const LOGO_URL = 'https://customer-assets-cm19k8pv.emergentagent.net/job_funding-express/artifacts/qg17fdy9_35552a2f-4e1d-4b3f-9832-d6167acc83d5.png';

// Sleek Business logo — uploaded PNG (contains full wordmark + tagline)
export default function Logo({ variant = 'dark', height = 44, className = '', showText = true }) {
  const invert = variant === 'light' ? 'brightness(0) invert(1)' : 'none';
  const textColor = variant === 'light' ? '#ffffff' : '#0a2540';
  const accentColor = variant === 'light' ? '#5eead4' : '#0d9488';

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img
        src={LOGO_URL}
        alt="Sleek Business — Smart Finance. Stronger Business."
        className="object-contain flex-shrink-0"
        style={{ height, width: 'auto', filter: invert }}
      />
      {showText && (
        <div className="hidden sm:flex flex-col leading-tight border-l pl-4" style={{ borderColor: variant === 'light' ? 'rgba(255,255,255,0.2)' : 'rgba(10,37,64,0.15)' }}>
          <span className="font-extrabold tracking-tight text-[24px]" style={{ color: textColor }}>
            Sleek Business
          </span>
          <span className="font-semibold text-[11px] tracking-[0.15em] uppercase mt-1" style={{ color: accentColor }}>
            Smart Finance. Stronger Business.
          </span>
        </div>
      )}
    </div>
  );
}
